import React from "react";
import { FacilityNavBar } from "../../../components";
import { useLoanDashboard, FacilityTab } from "../../../contexts";
import {
  FacilityOverview,
  FacilitySuppliers,
  FacilityDocuments,
  FacilitySettings,
} from "./FacilityDetailsTabs";
import { FACILITY_TABS } from "./constants";

const FacilityDetails: React.FC = () => {
  const {
    state: { facilityActiveTab },
    actions: { update },
  } = useLoanDashboard();

  const handleTabChange = (tabId: string) => {
    update({ facilityActiveTab: tabId });
  };

  const renderTabContent = () => {
    switch (facilityActiveTab) {
      case FacilityTab.OVERVIEW:
        return <FacilityOverview />;
      case FacilityTab.VENDORS:
        return <FacilitySuppliers />;
      case FacilityTab.DOCUMENTS:
        return <FacilityDocuments />;
      case FacilityTab.SETTINGS:
        return <FacilitySettings />;
      default:
        return <FacilityOverview />;
    }
  };

  return (
    <div className="cx-w-full cx-flex-1 cx-background-radial-gradient">
      <div className="cx-mt-6 cx-mb-6">
        <FacilityNavBar
          tabs={FACILITY_TABS}
          activeTab={facilityActiveTab}
          onTabChange={handleTabChange}
        />
      </div>
      {renderTabContent()}
    </div>
  );
};

export default FacilityDetails;
